export const MY_CHANGE_REQUESTS = 'profileChangeRequests@myRequests';
export const ALL_CHANGE_REQUESTS = 'profileChangeRequests@allRequests';

export default {
    [MY_CHANGE_REQUESTS]: { url: 'profile-change-request/get/my' },
    [ALL_CHANGE_REQUESTS]: { url: 'profile-change-request/get/all' }
};
